import { Box, Button, Typography } from '@mui/material'
import React from 'react'

const CustomBtn = ({ name, onclick, disabled = false }: { name: string, onclick: () => void, disabled?: boolean }) => {
    return (
        <Button
            onClick={onclick}
            disabled={disabled}
            fullWidth
            sx={{
                bgcolor: '#2a5298',
                borderRadius: "8px",
                boxShadow: 1,
                height: "30px !important",
                transition: 'all 0.3s ease-in-out',
                '&:hover': {
                    backgroundColor: '#1e3a6f',
                    boxShadow: 3,
                    transform: 'translateY(-2px)',
                    '& .MuiTypography-root': {
                        color: '#fff'
                    }
                },
                '&:active': {
                    transform: 'translateY(0px)',
                    boxShadow: 2,
                },
                '&.Mui-disabled': {
                    bgcolor: '#cccccc',
                    cursor: 'not-allowed',
                    '& .MuiTypography-root': {
                        color: '#666666'
                    }
                }
            }}>
            <Typography variant="h6" sx={{
                fontWeight: 500,
                fontSize: '0.9375rem',
                color: '#fff',
                transition: 'color 0.3s ease-in-out',
            }}>
                {
                    name
                }
            </Typography>
        </Button>
    )
}

export default CustomBtn